import { createStore, withProps } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { withRequestsStatus } from "@ngneat/elf-requests";

import { CategoryChildren, CategoryChildrenFilter } from "./categoryChildren.models";
import { PaginationDto } from "@utils/pagination.dto";

interface CategoryChildrenStoreProps {
  filters: CategoryChildrenFilter;
  pagination?: PaginationDto;
}

export const categoryChildrenStore = createStore(
  { name: "categoryChildren" },
  withProps<CategoryChildrenStoreProps>({
    filters: { page: 1, orderBy: "name" },
  }),
  withEntities<CategoryChildren>(),
  withRequestsStatus()
);
